/* ---------------------------------------------------------------
   Product gallery — thumbnail strip beneath the main image.

   The layout itself is CSS (pdp-thumbs-below.css). Three things have
   to change in script.

   1. Thumbnail clicks. Every image in this gallery carries the
      theme's zoom class, thumbnails included, so a click on a thumb
      both swaps the hero AND opens the lightbox. Removing the class
      loses a race with the theme's own code, which re-applies it
      after the media loads. Taking the click in the CAPTURE phase and
      driving the slider by hand is the only reliable fix: the
      lightbox handler never sees the event.

   2. The main slider's mousewheel binding. On the left-rail layout
      the wheel cycles images, which on this layout means the page
      stops scrolling whenever the cursor is over the gallery. The
      strip is how you change image here.

   3. The slide direction on a phone. The theme's slider_direction
      setting is applied to the base params AND to the 750 breakpoint,
      so the gallery swipes top-to-bottom on mobile and fights the
      page scroll. Below 750 the direction is forced to horizontal —
      one image at a time, swipe sideways or use the thumbnails.
      Desktop keeps the theme's setting untouched.
   --------------------------------------------------------------- */

(function () {
	var ATTEMPT_LIMIT = 20;
	var MOBILE = '(max-width: 749px)';
	var sliders = [];

	function wantedDirection() {
		return window.matchMedia(MOBILE).matches ? 'horizontal' : 'vertical';
	}

	function applyDirection(swiper) {
		if (!swiper || typeof swiper.changeDirection !== 'function') return;
		if (swiper.destroyed) return;

		var wanted = wantedDirection();
		if (swiper.params.direction === wanted) return;

		swiper.changeDirection(wanted, true);
	}

	function bindThumb(item, index, swiper) {
		if (item.dataset.thumbsBelowClick === 'true') return;
		item.dataset.thumbsBelowClick = 'true';

		item.addEventListener(
			'click',
			function (event) {
				event.preventDefault();
				event.stopPropagation();
				if (!swiper.destroyed) swiper.slideTo(index);
			},
			true // capture: run before the lightbox's own listener
		);
	}

	function release(outer) {
		if (outer.dataset.thumbsBelowBound === 'true') return true;

		var main = outer.querySelector('.js-media-list');
		if (!main) return true; // nothing to do on this layout
		if (!main.swiper) return false; // slider not up yet — try again

		outer.dataset.thumbsBelowBound = 'true';

		var swiper = main.swiper;

		var mousewheel = swiper.mousewheel;
		if (mousewheel && typeof mousewheel.disable === 'function') {
			mousewheel.disable();
		}

		var thumbs = outer.querySelectorAll('.product__media-subitem');
		for (var i = 0; i < thumbs.length; i++) {
			bindThumb(thumbs[i], i, swiper);
		}

		applyDirection(swiper);

		// Swiper re-applies its breakpoint params whenever the viewport
		// crosses 750, which puts the direction back to vertical — so the
		// choice has to be re-asserted after it does, not just once.
		swiper.on('breakpoint', function () {
			applyDirection(swiper);
		});

		if (sliders.indexOf(swiper) === -1) sliders.push(swiper);

		return true;
	}

	function init(attempt) {
		var outers = document.querySelectorAll('.product__outer--thumbs-aside');
		if (!outers.length) return;

		var pending = false;
		for (var i = 0; i < outers.length; i++) {
			if (!release(outers[i])) pending = true;
		}

		if (pending && attempt < ATTEMPT_LIMIT) {
			setTimeout(function () {
				init(attempt + 1);
			}, 100);
		}
	}

	var resizeTimer = null;
	window.addEventListener('resize', function () {
		if (resizeTimer) clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function () {
			for (var i = 0; i < sliders.length; i++) applyDirection(sliders[i]);
		}, 150);
	});

	document.addEventListener('shopify:section:load', function () {
		var outers = document.querySelectorAll('.product__outer--thumbs-aside');
		for (var i = 0; i < outers.length; i++) {
			delete outers[i].dataset.thumbsBelowBound;
			var thumbs = outers[i].querySelectorAll('.product__media-subitem');
			for (var t = 0; t < thumbs.length; t++) {
				delete thumbs[t].dataset.thumbsBelowClick;
			}
		}
		sliders = [];
		init(0);
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			init(0);
		});
	} else {
		init(0);
	}
})();